(function () {
    if (window.__client_check_injected) {
        return;
    }

    window.__client_check_injected = true;

    // ───────────────────────────────────────────────
    // 1️⃣ Stable device token (local, privacy-safe)
    // ───────────────────────────────────────────────
    let token = localStorage.getItem('device_token');

    if (!token) {
        token = crypto.randomUUID();
        localStorage.setItem('device_token', token);
    }

    // ───────────────────────────────────────────────
    // 2️⃣ Collect environment info
    // ───────────────────────────────────────────────
    const payload = {
        deviceToken: token,
        capable: !!window.PublicKeyCredential,
        ua: navigator.userAgent || null,
        lang: navigator.language || null,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            availWidth: window.screen.availWidth,
            availHeight: window.screen.availHeight,
            colorDepth: window.screen.colorDepth,
            pixelRatio: window.devicePixelRatio
        },
        platform: navigator.platform || null,
        maxTouchPoints: Number.isFinite(navigator.maxTouchPoints) ? navigator.maxTouchPoints : 0,
        touch: ('ontouchstart' in window) || (navigator.maxTouchPoints > 0),
        cookies: navigator.cookieEnabled,
        dnt: navigator.doNotTrack || null,
        fonts: (() => {
            try {
                return document.fonts ? document.fonts.size : null;
            } catch (e) {
                return null;
            }
        })(),
        timestamp: Date.now()
    };

    // ───────────────────────────────────────────────
    // 3️⃣ POST to server (authoritative)
    // ───────────────────────────────────────────────
    fetch('/api/clientcheck/check-client', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
        .then(async response => {
            if (!response.ok) {
                throw new Error('Client check failed with status ' + response.status);
            }

            const responseData = await response.json();

            const redirect = typeof responseData.redirect === 'string'
                ? responseData.redirect
                : responseData
                    && responseData.data
                    && typeof responseData.data.redirect === 'string'
                        ? responseData.data.redirect
                        : null;

            if (redirect === null) {
                throw new Error('Invalid redirect response');
            }

            // ───────────────────────────────────────────
            // 4️⃣ Obey server redirect
            // Internal forward keeps the original URL in the address bar while
            // showing checkclient HTML — assign() is a no-op when the target
            // matches the current location, so force a reload in that case.
            // ───────────────────────────────────────────
            const target = new URL(redirect, window.location.href);
            const sameDestination =
                target.host === window.location.host
                && target.pathname === window.location.pathname
                && target.search === window.location.search
                && target.hash === window.location.hash;

            if (sameDestination) {
                window.location.reload();
                return;
            }

            window.location.assign(target.href);
        })
        .catch(err => {
            console.error('[Heliont ClientCheck] Failed:', err);
        });
})();
